import { z } from 'zod';

/** Готовый вопрос аватару из подсказок на экране чата. */
export interface PersonQuestionModel {
  readonly id: number;
  readonly question: string;
}

/** Переименований нет — ключи `id` и `question` одинаковы в сети и в модели. */
export const personQuestionModelSchema = z.object({
  // `(json['id'] as num).toInt()` — Dart усекает дробную часть.
  id: z.number().transform((value) => Math.trunc(value)),
  question: z.string(),
});

export function personQuestionModelFromJson(
  json: unknown,
): PersonQuestionModel {
  return personQuestionModelSchema.parse(json);
}

export function personQuestionModelToJson(
  model: PersonQuestionModel,
): Record<string, unknown> {
  return {
    id: model.id,
    question: model.question,
  };
}
